import React, { useState } from 'react'
import {
  Card, CardBody, Col, Form,
  Input, Label, Row, Spinner, Table, Badge,
} from 'reactstrap'
import QdContainer from 'components/Common/QdContainer'
import Cookies from 'js-cookie'

const INTEGRATION_TYPES = [
  { value: 'mcleod_gen',     label: 'McLeod Standard API' },
  { value: 'mcleod_qued',    label: 'McLeod Qued API' },
  { value: 'mcleod_gen_25',  label: 'McLeod Standard V25 API' },
  { value: 'mcleod_qued_25', label: 'McLeod Qued V25 API' },
  { value: 'MC_API',         label: 'Motor City Integration' },
  { value: 'TAI',            label: 'TAI TMS Integration' },
  { value: 'QUED_API',       label: 'Standard Qued API Integration' },
  { value: 'CLL_API',        label: 'Consolidated Qued API Integration' },
  { value: 'CL_API',         label: 'Estes/Ward Qued API Integration' },
  { value: 'REVENOVA',       label: 'Revenova/Salesforce Integration' },
  { value: 'TURVO',          label: 'Turvo Integration' },
  { value: 'ALJEX',          label: 'Aljex Integration' },
  { value: 'ALVYS',          label: 'Alvys Integration' },
  { value: 'EMAIL_FILE',     label: 'File via Email Integration' },
  { value: 'SFTP_PUSH',      label: 'FTP Integration (Customer Push)' },
  { value: 'SFTP_PULL',      label: 'FTP Integration (Qued Pull)' }
]

function OnboardingNew() {
  const [form, setForm] = useState({
    scac: '',
    tenant_name: '',
    email_id: '',
    email_firstname: '',
    email_lastname: '',
    integration_type: '',
  })
  const [results, setResults] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const handleChange = (e) => {
    const { name, value } = e.target
    setForm(prev => ({
      ...prev,
      [name]: name === 'scac' ? value.toUpperCase() : value,
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError(null)
    setResults(null)

    try {
      const token = Cookies.get('idToken')
      const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }

      const params = new URLSearchParams(form)
      const api_url = process.env.REACT_APP_API_URL
      const res = await fetch(`${api_url}crs/tenant-onboarding?${params.toString()}`, {
        method: 'POST',
        headers,
        credentials: 'include',
      })

      if (!res.ok) throw new Error(`Request failed: ${res.status} ${res.statusText}`)
      const data = await res.json()
      setResults(data)
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  const successCount = results ? results.filter(r => r.status === 'success').length : 0
  const errorCount = results ? results.filter(r => r.status === 'error').length : 0

  return (
    <QdContainer>
      <Row>
        <Col lg={7}>
          <Card className="p-3 shadow-sm">
            <CardBody className="p-0">
              <h6
                style={{
                  fontSize: '14px',
                  fontWeight: '600',
                  borderBottom: '2px solid #EE5A29',
                  paddingBottom: '6px',
                  display: 'inline-block',
                  marginBottom: '20px',
                  color: '#EE5A29',
                }}
              >
                Onboarding New
              </h6>
              <Form onSubmit={handleSubmit} className="p-2">
                <Row className="mb-4">
                  <Label className="col-sm-3 col-form-label">SCAC Code</Label>
                  <Col sm={6}>
                    <Input
                      type="text"
                      className="form-control"
                      name="scac"
                      value={form.scac}
                      onChange={handleChange}
                      required
                    />
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Label className="col-sm-3 col-form-label">Tenant Name</Label>
                  <Col sm={6}>
                    <Input
                      type="text"
                      className="form-control"
                      name="tenant_name"
                      value={form.tenant_name}
                      onChange={handleChange}
                      required
                    />
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Label className="col-sm-3 col-form-label">Email Id</Label>
                  <Col sm={6}>
                    <Input
                      type="email"
                      className="form-control"
                      name="email_id"
                      value={form.email_id}
                      onChange={handleChange}
                      required
                    />
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Label className="col-sm-3 col-form-label">Email First Name</Label>
                  <Col sm={6}>
                    <Input
                      type="text"
                      className="form-control"
                      name="email_firstname"
                      value={form.email_firstname}
                      onChange={handleChange}
                      required
                    />
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Label className="col-sm-3 col-form-label">Email Last Name</Label>
                  <Col sm={6}>
                    <Input
                      type="text"
                      className="form-control"
                      name="email_lastname"
                      value={form.email_lastname}
                      onChange={handleChange}
                      required
                    />
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Label className="col-sm-3 col-form-label">Integration Type</Label>
                  <Col sm={6}>
                    <Input
                      type="select"
                      className="form-control"
                      name="integration_type"
                      value={form.integration_type}
                      onChange={handleChange}
                      required
                    >
                      <option value="">-- Select --</option>
                      {INTEGRATION_TYPES.map(opt => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                      ))}
                    </Input>
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col sm={{ offset: 3 }}>
                    <button type="submit" className="btn btn-primary btn-sm" disabled={loading}>
                      {loading ? <Spinner size="sm" /> : 'Submit'}
                    </button>
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>

      {error && (
        <Row className="mt-3">
          <Col lg={7}>
            <div className="alert alert-danger" style={{ fontSize: '13px' }}>{error}</div>
          </Col>
        </Row>
      )}

      {results && (
        <Row className="mt-3">
          <Col lg={7}>
            <Card className="shadow-sm">
              <CardBody className="p-3">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h6
                    style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      borderBottom: '2px solid #EE5A29',
                      paddingBottom: '6px',
                      display: 'inline-block',
                      color: '#EE5A29',
                      marginBottom: 0,
                    }}
                  >
                    Results
                  </h6>
                  <span className="text-muted" style={{ fontSize: '12px' }}>
                    {results.length} checks &nbsp;·&nbsp;
                    <span style={{ color: '#34c38f', fontWeight: 600 }}>{successCount} passed</span>
                    &nbsp;·&nbsp;
                    <span style={{ color: '#f46a6a', fontWeight: 600 }}>{errorCount} failed</span>
                  </span>
                </div>
                <Table
                  hover
                  responsive
                  className="mb-0"
                  style={{ fontFamily: 'Inter, Poppins, sans-serif', fontSize: '13px' }}
                >
                  <thead className="table-light">
                    <tr>
                      <th style={{ fontWeight: '600', width: '85%' }}>Check</th>
                      <th style={{ fontWeight: '600', width: '15%', textAlign: 'center' }}>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {results.map((item, idx) => {
                      const isSuccess = item.status === 'success'
                      return (
                        <tr key={idx}>
                          <td style={{ verticalAlign: 'middle', color: isSuccess ? '#1a7a55' : '#c0392b' }}>
                            {item.message}
                          </td>
                          <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                            <Badge
                              color={isSuccess ? 'success' : 'danger'}
                              style={{ fontSize: '11px', padding: '4px 8px', minWidth: '52px', display: 'inline-block' }}
                            >
                              {isSuccess ? 'OK' : 'Error'}
                            </Badge>
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </QdContainer>
  )
}

export default OnboardingNew
